import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router-dom';
import useIsActive from '~/hooks/useIsActive';
import { useIsWidgetAuth } from '~/providers/AutoAuthProvider';
import MeasurementsProvider from '~/providers/MeasurementsProvider';
import EmbeddedLayout from './EmbeddedLayout';
import StandaloneLayout from './StandaloneLayout';
import SubscriptionExpired from './SubscriptionExpired';

export default function AppLayout() {
  const isWidgetAuth = useIsWidgetAuth();

  const Layout = isWidgetAuth ? EmbeddedLayout : StandaloneLayout;

  const isActive = useIsActive();

  return (
    <MeasurementsProvider>
      <Layout>{isActive ? <Outlet /> : <SubscriptionExpired />}</Layout>
      <Toaster />
    </MeasurementsProvider>
  );
}
